import React from 'react';
import PollOpen from './Open';
import PollRating from './Rating';
import PollStandard from './Standard';

export default ({ poll, preview, onAnswer, authorizationCheck }) => {

    switch (poll.type) {
        case 'open':
            return <PollOpen poll={poll} preview={preview} onAnswer={onAnswer} authorizationCheck={authorizationCheck} />;
        case 'rating':
            return <PollRating poll={poll} preview={preview} onAnswer={onAnswer} authorizationCheck={authorizationCheck} />;
        default:
            return <PollStandard poll={poll} preview={preview} onAnswer={onAnswer} authorizationCheck={authorizationCheck} />;
    }
};
